<template>
  <div id="MainCy"></div>
</template>
<script>
let url = {
  specie_cytoscape_data: 'species/specie_cytoscape_data', // 获取cytoscape 数据
}
import { nodesData, edgesData } from './cyData'
import { cyStyle, layout } from './config'
export default {
  props: ['start_id', 'sort', 'species'],
  data() {
    return {
      layout: layout,
      cyStyle: cyStyle,
      nodes: nodesData,
      edges: edgesData,
    }
  },
  created() {
    this.getCytoscapeData()
  },
  //   mounted() {
  //       this.cytoscape()
  //   },
  methods: {
    getCytoscapeData() {
      let params = {
        start_id: this.start_id,
        sort: this.sort,
        species: this.species,
      }
      this.http
        .get(url.specie_cytoscape_data, params)
        .then((res) => {
          if (res.data.code == 200) {
            this.nodes = res.data.data.node_data
            this.edges = res.data.data.relation_data
          }
          // 返回成功后在显示cytoscape
          this.cytoscape()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    cytoscape() {
      let that = this
      let cy = that.$cytoscape({
        container: document.getElementById('MainCy'),
        layout: that.layout,
        style: that.cyStyle,
        elements: {
          nodes: that.nodes,
          edges: that.edges,
        },
      })
      let centerNode = `node[id='${that.start_id}']`
      // 更新现有样式表(中心点的样式更改)
      cy.style()
        .selector(centerNode)
        .style({
          'border-width': '3px',
          'border-color': '#000000',
          'border-opacity': '0.8',
        })
        .update()

      // cy.center(cy.$(centerNode))

      cy.nodes().on('click', function (evt) {
        let nodeId = this.data('id')
        let nodeType = this.data('type')
        if (nodeType == 'lncRNA' || nodeType == 'validate_lncRNA') {
          sessionStorage.setItem('lncRNA_id', nodeId)
          if (that.$route.path == '/nunMir') {
            that.$router.go(0)
            window, scrollTo(0, 0)
          } else {
            that.$router.push({
              path: '/nunMir',
            })
            window, scrollTo(0, 0)
          }
        } else if (nodeType == 'isoform_id') {
          sessionStorage.setItem('isoform_id', nodeId)

          if (that.$route.path == '/nunMirGene') {
            that.$router.go(0)
            window, scrollTo(0, 0)
          } else {
            that.$router.push({
              path: '/nunMirGene',
            })
            window, scrollTo(0, 0)
          }
        } else if (nodeType == 'miRNA') {
          window.open(`http://www.pmiren.com/singlemirna?Accession=${this.data('accession')}`, '_blank')
        }
      })
    },
  },
}
</script>

<style scoped>
#MainCy {
  width: 100%;
  height: 600px;
  margin: 0 auto;
}
</style>
